import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const video = document.querySelector(".kits-hero__video");
const bottom = document.querySelector(".kits-hero__bottom");
const vottomVideo = document.querySelector('.kits-hero__bottom-video')
const block = document.querySelector(".kits-hero__video-wrap");
const vw = Math.min(window.innerWidth, 1920);
const offset = Math.round(video.getBoundingClientRect().top + window.scrollY).toString();
const mobileOffset = `top top+=${offset}`
function getHeightFromWidth(width) {
  if (vw > 767) {
    return width * 9 / 16;
  }

  return width * 1 / 1;
}


if (video && block) {
  const offset = Math.max(0, (vw - getPx().w) / 2);

  function getPx(isFull = false) {
    let w = vw <= 1320 ? vw - 64 : 1320;
    let videoH = 790;
    if (vw < 767) {
      videoH = 410;
    }
    if (vw < 760) {
      w = w - 64;
    }

    const h = Math.max(0, videoH - w / 2.2);

    if (isFull) {
      return { w, h: videoH - vw / 1.9 };
    }

    return { w, h };
  }

  const getEnd = () => {
    if (vw > 900) {
      return "+=1900"
    }
    if (vw > 767) {
      return "+=1600"
    }

    return "+=600"
  }

  gsap.set(video, {
    width: vw - (offset * 2),
    height: getHeightFromWidth(vw - (offset * 2))
  });

  if (vw < 767) {

    const tl_apin = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: mobileOffset,
        end: "top top+=350",
        scrub: 0.001,
        pin: false,
        pinSpacing: false,
        markers: false,
      },
    });
    tl_apin.to(video, {
      width: vw,
      height: getHeightFromWidth(vw),
    }, 0);
    tl_apin.eventCallback("onComplete", () => {
      gsap.set(video, {
        width: vw,
        height: getHeightFromWidth(vw),
      });
    });
    const tl = gsap.timeline({ 
      scrollTrigger: {
        trigger: block,
        start: "top top+=320",
        end: getEnd,
        scrub: 0.001,
        pin: true,
        pinSpacing: false,
        markers: false,
        invalidateOnRefresh: true,
        onEnter: () => {
          const minWw = getHeightFromWidth(vw - 44)
          console.log(minWw);
          
vottomVideo.style.height = `${minWw * 1 / 1}px`
          gsap.set(video, { width: vw, height: getHeightFromWidth(vw) });
        }
      },
    });

    tl.to(video, {
      width: () => {
        const vw = Math.min(window.innerWidth, 1920);
        const offset = Math.max(0, (vw - 360) / 2);
        return vw - (offset * 2)
      },
      height: () => {
        const vw = Math.min(window.innerWidth, 1920);
        const offset = Math.max(0, (vw - 360) / 2);
        return getHeightFromWidth(vw - (offset * 2))
      },
      ease: "none",
      immediateRender: false,
    }, 0);
  } else {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top top+=100",
        end: getEnd,
        scrub: 0.001,
        pin: true,
        pinSpacing: false,
        markers: false,
      },
    });

    gsap.set(video, {
      width: vw - (offset * 2),
      height: getHeightFromWidth(vw - (offset * 2))
    });

    tl.to(video, {
      width: vw,
      height: getHeightFromWidth(vw)
    }, 0);


    tl.to(video, {
      width: () => {
        const vw = Math.min(window.innerWidth, 1920);
        const offset = Math.max(0, (vw - 360) / 2);
        return vw - (offset * 2)
      },
      height: () => {
        const vw = Math.min(window.innerWidth, 1920);
        const offset = Math.max(0, (vw - 360) / 2);
        return getHeightFromWidth(vw - (offset * 2))
      },
      ease: "none"
    }, 0.5);
  }
  const section = document.querySelector('.kits-hero')
  const blurBal = document.querySelector('.kits-hero__blur-wrapper');

  if (section && blurBal && window.innerWidth >= 1024) {
    let mouseX = 0;
    let mouseY = 0;
    let currentX = 0;
    let currentY = 0;

    let isHovering = false;
    let animating = false;
    let isVisible = true;
    let justEntered = true;

    section.addEventListener('mouseenter', (e) => {
      const rect = section.getBoundingClientRect();

      const offsetX = blurBal.offsetWidth / 2;
      const offsetY = blurBal.offsetHeight / 2;

      mouseX = e.clientX - rect.left - offsetX;
      mouseY = e.clientY - rect.top - offsetY;


      if (justEntered) {
        currentX += (mouseX - currentX) * 0.2;
        currentY += (mouseY - currentY) * 0.2;
        justEntered = false;
      }

      isHovering = true;
      if (!animating && isVisible) animate();
    });

    section.addEventListener('mouseleave', () => {
      isHovering = false;
      justEntered = true;
    });

    section.addEventListener('mousemove', (e) => {
      const rect = section.getBoundingClientRect();

      const offsetX = blurBal.offsetWidth / 2;
      const offsetY = blurBal.offsetHeight / 2;

      mouseX = e.clientX - rect.left - offsetX;
      mouseY = e.clientY - rect.top - offsetY;
    });

    function animate() {
      animating = true;

      const dx = mouseX - currentX;
      const dy = mouseY - currentY;

      const needsUpdate = Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1;

      if ((isHovering || needsUpdate) && isVisible) {
        currentX += dx * 0.04;
        currentY += dy * 0.04;

        blurBal.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;

        requestAnimationFrame(animate);
      } else {
        animating = false;
      }
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
        if (isVisible && isHovering && !animating) {
          animate();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  }
}